import React, { useEffect, useState } from "react";
import { CircularProgress, Box, Pagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import commonStyles from "../../styles/Common.module.css";

const BASE_URL = "https://api.sovrenn.com";
const PAGE_SIZE = 500;

const DailyLogs = () => {
    const navigate = useNavigate();
    const [days, setDays] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        const fetchLogs = async () => {
            setIsLoading(true);
            try {
                const res = await fetch(
                    `${BASE_URL}/search-history/daily-logs?page=${page}&page_size=${PAGE_SIZE}`,
                    { headers: { "Authorization": "Bearer " + localStorage.getItem("sov_user") } }
                );
                const result = await res.json();
                if (result.success) {
                    setDays(result.data);
                    setTotalPages(result.pagination.total_pages);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchLogs();
    }, [page]);

    return (
        <div className={commonStyles.MainContainer} style={{ maxWidth: "900px" }}>
            <div className={commonStyles.headerDiv}>
                <h1>Daily Search Logs</h1>
            </div>

            {isLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", margin: "100px auto", width: 100 }}>
                    <CircularProgress />
                </Box>
            ) : days.length === 0 ? (
                <p style={{ textAlign: "center", color: "#999", marginTop: "60px" }}>No logs found.</p>
            ) : (
                <>
                    {days.map((day) => (
                        <div key={day.date} style={{ marginBottom: "32px" }}>
                            <div style={{
                                display: "inline-block",
                                backgroundColor: "#1976d2",
                                color: "#fff",
                                fontSize: "13px",
                                fontWeight: "700",
                                padding: "5px 14px",
                                borderRadius: "20px",
                                marginBottom: "12px"
                            }}>
                                {new Date(day.date + "T00:00:00").toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                {day.logs.map((log, ind) => (
                                    <div key={ind} style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "10px 16px",
                                        background: "#fff",
                                        border: "1px solid #ebebeb",
                                        borderRadius: "8px",
                                        fontSize: "14px",
                                        color: "#333"
                                    }}>
                                        <span>
                                            <strong
                                                onClick={() => log.user_id && !["Guest", "Unknown"].includes(log.user_name) && navigate(`/users/${log.user_id}`)}
                                                style={{ cursor: log.user_id && !["Guest", "Unknown"].includes(log.user_name) ? "pointer" : "default", textDecoration: !["Guest", "Unknown"].includes(log.user_name) ? "underline" : "none" }}
                                            >
                                                {log.user_name}
                                            </strong> searched <strong>{log.company_name}</strong>
                                        </span>
                                        <span style={{ color: "#888", fontSize: "13px", whiteSpace: "nowrap", marginLeft: "16px" }}>
                                            {log.time}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}

                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, val) => setPage(val)}
                        color="primary"
                        style={{ marginTop: "24px" }}
                    />
                </>
            )}
        </div>
    );
};

export default DailyLogs;
